module["exports"] = [
  "Affenpinscher",
  "Afghan Hound",
  "Aidi",
  "Airedale Terrier",
  "Akbash",
  "Akita",
  "Alano Español",
  "Alapaha Blue Blood Bulldog",
  "Alaskan Husky",
  "Alaskan Klee Kai",
  "Alaskan Malamute",
  "Alopekis",
  "Alpine Dachsbracke",
  "American Bulldog",
  "American Bully",
  "American Cocker Spaniel",
  "American English Coonhound",
  "American Foxhound",
  "American Hairless Terrier",
  "American Pit Bull Terrier",
  "American Staffordshire Terrier",
  "American Water Spaniel",
  "Andalusian Hound",
  "Anglo-Français de Petite Vénerie",
  "Appenzeller Sennenhund",
  "Ariegeois",
  "Armant",
  "Armenian Gampr dog",
  "Artois Hound",
  "Australian Cattle Dog",
  "Australian Kelpie",
  "Australian Shepherd",
  "Australian Stumpy Tail Cattle Dog",
  "Australian Terrier",
  "Austrian Black and Tan Hound",
  "Austrian Pinscher",
  "Azawakh",
  "Bakharwal dog",
  "Banjara Hound",
  "Barbado da Terceira",
  "Barbet",
  "Basenji",
  "Basque Shepherd Dog",
  "Basset Artésien Normand",
  "Basset Bleu de Gascogne",
  "Basset Fauve de Bretagne",
  "Basset Hound",
  "Bavarian Mountain Hound",
  "Beagle",
  "Beagle-Harrier",
  "Belgian Shepherd",
  "Bearded Collie",
  "Beauceron",
  "Bedlington Terrier",
  "Bergamasco Shepherd",
  "Berger Picard",
  "Bernese Mountain Dog",
  "Bhotia",
  "Bichon Frisé",
  "Billy",
  "Black and Tan Coonhound",
  "Black Norwegian Elkhound",
  "Black Russian Terrier",
  "Black Mouth Cur",
  "Bloodhound",
  "Blue Lacy",
  "Blue Picardy Spaniel",
  "Bluetick Coonhound",
  "Boerboel",
  "Bohemian Shepherd",
  "Bolognese",
  "Border Collie",
  "Border Terrier",
  "Borzoi",
  'Bosnian Coarse-haired Hound',
  "Boston Terrier",
  "Bouvier des Ardennes",
  "Bouvier des Flandres",
  "Boxer",
  "Boykin Spaniel",
  "Bracco Italiano",
  "Braque d'Auvergne",
  "Braque de l'Ariège",
  "Braque du Bourbonnais",
  "Braque Francais",
  "Braque Saint-Germain",
  "Briard",
  "Briquet Griffon Vendéen",
  "Brittany",
  "Broholmer",
  "Bruno Jura Hound",
  "Brussels Griffon",
  "Bucovina Shepherd Dog",
  "Bull Arab",
  "Bull Terrier",
  "Bulldog",
  "Bullmastiff",
  "Bully Kutta",
  'Burgos Pointer',
  "Cairn Terrier",
  "Campeiro Bulldog",
  "Canaan Dog",
  "Canadian Eskimo Dog",
  "Cane Corso",
  "Cane di Oropa",
  "Cane Paratore",
  "Cantabrian Water Dog",
  "Can de Chira",
  "Cão da Serra de Aires",
  "Cão de Castro Laboreiro",
  "Cão de Gado Transmontano",
  "Cão Fila de São Miguel",
  "Cardigan Welsh Corgi",
  "Carea Castellano Manchego",
  "Carolina Dog",
  "Carpathian Shepherd Dog",
  "Catahoula Leopard Dog",
  "Catalan Sheepdog",
  "Caucasian Shepherd Dog",
  "Cavalier King Charles Spaniel",
  "Central Asian Shepherd Dog",
  "Cesky Fousek",
  "Cesky Terrier",
  "Chesapeake Bay Retriever",
  "Chien Français Blanc et Noir",
  "Chien Français Blanc et Orange",
  "Chien Français Tricolore",
  "Chihuahua",
  "Chilean Terrier",
  "Chinese Chongqing Dog",
  "Chinese Crested Dog",
  "Chinook",
  "Chippiparai",
  "Chongqing dog",
  "Chortai",
  "Chow Chow",
  "Cimarrón Uruguayo",
  "Cirneco dell'Etna",
  "Clumber Spaniel",
  "Colombian fino hound",
  "Coton de Tulear",
  "Cretan Hound",
  "Croatian Sheepdog",
  "Curly-Coated Retriever",
  "Cursinu",
  "Czechoslovakian Wolfdog",
  "Dachshund",
  "Dalmatian",
  "Dandie Dinmont Terrier",
  "Danish-Swedish Farmdog",
  "Denmark Feist",
  "Dingo" ,
  "Doberman Pinscher",
  "Dogo Argentino",
  "Dogo Guatemalteco",
  "Dogo Sardesco",
  "Dogue Brasileiro",
  "Dogue de Bordeaux",
  "Drentse Patrijshond",
  "Drever",
  "Dunker",
  "Dutch Shepherd",
  "Dutch Smoushond",
  "East Siberian Laika",
  "East European Shepherd",
  "English Cocker Spaniel",
  "English Foxhound",
  "English Mastiff",
  "English Setter",
  "English Shepherd",
  "English Springer Spaniel",
  "English Toy Terrier",
  "Entlebucher Mountain Dog",
  "Estonian Hound",
  "Estrela Mountain Dog",
  "Eurasier",
  "Field Spaniel",
  "Fila Brasileiro",
  "Finnish Hound",
  "Finnish Lapphund",
  "Finnish Spitz",
  "Flat-Coated Retriever",
  "French Bulldog",
  "French Spaniel",
  "Galgo Español",
  "Galician Shepherd Dog",
  "Garafian Shepherd",
  "Gascon Saintongeois",
  "Georgian Shepherd",
  "German Hound",
  "German Longhaired Pointer",
  "German Pinscher",
  "German Roughhaired Pointer",
  "German Shepherd Dog",
  "German Shorthaired Pointer",
  "German Spaniel",
  "German Spitz",
  "German Wirehaired Pointer",
  "Giant Schnauzer",
  "Glen of Imaal Terrier",
  "Golden Retriever",
  "Gończy Polski",
  "Gordon Setter",
  "Grand Anglo-Français Blanc et Noir",
  "Grand Anglo-Français Blanc et Orange",
  "Grand Anglo-Français Tricolore",
  "Grand Basset Griffon Vendéen",
  "Grand Bleu de Gascogne",
  "Grand Griffon Vendéen",
  "Great Dane",
  "Greater Swiss Mountain Dog",
  "Greek Harehound",
  "Greek Shepherd",
  "Greenland Dog",
  "Greyhound",
  "Griffon Bleu de Gascogne",
  "Griffon Fauve de Bretagne",
  "Griffon Nivernais",
  "Gull Dong",
  "Gull Terrier",
  "Hällefors Elkhound",
  "Hamiltonstövare",
  "Hanover Hound",
  "Harrier",
  "Havanese",
  "Hierran Wolfdog",
  "Hokkaido",
  "Hovawart",
  "Huntaway",
  "Hygen Hound",
  "Ibizan Hound",
  "Icelandic Sheepdog",
  "Indian pariah dog",
  "Indian Spitz",
  "Irish Red and White Setter",
  "Irish Setter",
  "Irish Terrier",
  "Irish Water Spaniel",
  "Irish Wolfhound",
  "Istrian Coarse-haired Hound",
  "Istrian Shorthaired Hound",
  "Italian Greyhound",
  "Jack Russell Terrier",
  "Jagdterrier",
  "Japanese Chin",
  "Japanese Spitz",
  "Japanese Terrier",
  "Jindo",
  "Jonangi",
  "Kai Ken",
  "Kaikadi",
  "Kangal Shepherd Dog",
  "Kanni",
  "Karakachan dog",
  "Karelian Bear Dog",
  "Kars",
  "Karst Shepherd",
  "Keeshond",
  "Kerry Beagle",
  "Kerry Blue Terrier",
  "King Charles Spaniel",
  "King Shepherd",
  "Kintamani",
  "Kishu",
  "Kokoni",
  "Kombai",
  "Komondor",
  "Kooikerhondje",
  "Koolie",
  "Koyun dog",
  "Kromfohrländer",
  "Kuchi",
  "Kuvasz",
  "Labrador Retriever",
  "Lagotto Romagnolo",
  "Lakeland Terrier",
  "Lancashire Heeler",
  "Landseer",
  "Lapponian Herder",
  "Large Münsterländer",
  "Leonberger",
  "Levriero Sardo",
  "Lhasa Apso",
  "Lithuanian Hound",
  "Löwchen",
  "Lupo Italiano",
  "Mackenzie River Husky",
  "Magyar agár",
  "Mahratta Greyhound",
  "Maltese",
  "Manchester Terrier",
  "Maremmano-Abruzzese Sheepdog",
  "McNab dog",
  "Miniature American Shepherd",
  "Miniature Bull Terrier",
  "Miniature Fox Terrier",
  "Miniature Pinscher",
  "Miniature Schnauzer",
  "Molossus of Epirus",
  "Montenegrin Mountain Hound",
  "Mountain Cur",
  "Mountain Feist",
  "Mucuchies",
  "Mudhol Hound",
  "Mudi",
  "Neapolitan Mastiff",
  "New Guinea Singing Dog",
  "New Zealand Heading Dog",
  "Newfoundland",
  "Norfolk Terrier",
  "Norrbottenspets",
  "Northern Inuit Dog",
  "Norwegian Buhund",
  "Norwegian Elkhound",
  "Norwegian Lundehund",
  "Norwich Terrier",
  "Nova Scotia Duck Tolling Retriever",
  "Old Croatian Sighthound",
  "Old Danish Pointer",
  "Old English Sheepdog",
  "Old English Terrier",
  "Olde English Bulldogge",
  "Otterhound",
  "Pachon Navarro",
  "Pampas Deerhound",
  "Paisley Terrier",
  "Papillon",
  "Parson Russell Terrier",
  "Pastore della Lessinia e del Lagorai",
  "Patagonian Sheepdog",
  "Patterdale Terrier",
  "Pekingese",
  "Pembroke Welsh Corgi",
  "Perro Majorero",
  "Perro de Pastor Mallorquin",
  "Perro de Presa Canario",
  "Perro de Presa Mallorquin",
  "Peruvian Inca Orchid",
  "Petit Basset Griffon Vendéen",
  "Petit Bleu de Gascogne",
  "Phalène",
  "Pharaoh Hound",
  "Phu Quoc Ridgeback",
  "Picardy Spaniel",
  "Plummer Terrier",
  "Plott Hound",
  "Podenco Canario",
  "Podenco Valenciano",
  "Pointer",
  "Poitevin",
  "Polish Greyhound",
  "Polish Hound",
  "Polish Lowland Sheepdog",
  "Polish Tatra Sheepdog",
  "Pomeranian",
  "Pont-Audemer Spaniel",
  "Poodle",
  "Porcelaine",
  "Portuguese Podengo",
  "Portuguese Pointer",
  "Portuguese Water Dog",
  "Posavac Hound",
  "Pražský Krysařík",
  "Pshdar Dog",
  "Pudelpointer",
  "Pug",
  "Puli",
  "Pumi",
  "Pungsan Dog",
  "Pyrenean Mastiff",
  "Pyrenean Mountain Dog",
  "Pyrenean Sheepdog",
  "Rafeiro do Alentejo",
  "Rajapalayam",
  "Rampur Greyhound",
  "Rat Terrier",
  "Ratonero Bodeguero Andaluz",
  "Ratonero Mallorquin",
  "Ratonero Murciano de Huerta",
  "Ratonero Valenciano",
  "Redbone Coonhound",
  "Rhodesian Ridgeback",
  "Romanian Mioritic Shepherd Dog",
  "Romanian Raven Shepherd Dog",
  "Rottweiler",
  "Rough Collie",
  "Russian Spaniel",
  "Russian Toy",
  "Russo-European Laika",
  "Saarloos Wolfdog",
  "Sabueso Español",
  "Saint Bernard",
  "Saint Hubert Jura Hound",
  "Saint-Usuge Spaniel",
  "Saluki",
  "Samoyed",
  "Sapsali",
  "Sarabi dog",
  "Šarplaninac",
  "Schapendoes",
  "Schillerstövare",
  "Schipperke",
  "Schweizer Laufhund",
  "Schweizerischer Niederlaufhund",
  "Scottish Deerhound",
  "Scottish Terrier",
  "Sealyham Terrier",
  "Segugio dell'Appennino",
  "Segugio Italiano",
  "Segugio Maremmano",
  "Seppala Siberian Sleddog",
  "Serbian Hound",
  "Serbian Tricolour Hound",
  "Serrano Bulldog",
  "Shar Pei",
  "Shetland Sheepdog",
  "Shiba Inu",
  "Shih Tzu",
  "Shikoku",
  "Shiloh Shepherd",
  "Siberian Husky",
  "Silken Windhound",
  "Silky Terrier",
  "Sinhala Hound",
  "Skye Terrier",
  "Sloughi",
  "Slovakian Wirehaired Pointer",
  "Slovenský Cuvac",
  "Slovenský Kopov",
  "Smalandstövare",
  "Small Greek domestic dog",
  "Small Münsterländer",
  "Smooth Collie",
  "Smooth Fox Terrier",
  "Soft-Coated Wheaten Terrier",
  "South Russian Ovcharka",
  "Spanish Mastiff",
  "Spanish Water Dog",
  "Spinone Italiano",
  "Sporting Lucas Terrier",
  "Sardinian Shepherd Dog",
  "Stabyhoun",
  "Staffordshire Bull Terrier",
  "Standard Schnauzer",
  "Stephens Stock",
  "Styrian Coarse-haired Hound",
  "Sussex Spaniel",
  "Swedish Elkhound",
  "Swedish Lapphund",
  "Swedish Vallhund",
  "Swedish White Elkhound",
  "Taigan",
  "Taiwan Dog",
  "Tamaskan Dog",
  "Teddy Roosevelt Terrier",
  "Telomian",
  "Tenterfield Terrier",
  "Terrier Brasileiro",
  "Thai Bangkaew Dog",
  "Thai Ridgeback",
  "Tibetan Mastiff",
  "Tibetan Spaniel",
  "Tibetan Terrier",
  "Tornjak",
  "Tosa",
  "Toy Fox Terrier",
  "Toy Manchester Terrier",
  "Transylvanian Hound",
  "Treeing Cur",
  "Treeing Feist",
  "Treeing Tennessee Brindle",
  "Treeing Walker Coonhound",
  "Trigg Hound",
  "Tyrolean Hound",
  "Vikhan",
  "Villano de Las Encartaciones",
  "Villanuco de Las Encartaciones",
  "Vizsla",
  "Volpino Italiano",
  "Weimaraner",
  "Welsh Sheepdog",
  "Welsh Springer Spaniel",
  "Welsh Terrier",
  "West Highland White Terrier",
  "West Siberian Laika",
  "Westphalian Dachsbracke",
  "Wetterhoun",
  "Whippet",
  "White Shepherd",
  "White Swiss Shepherd Dog",
  "Wire Fox Terrier",
  "Wirehaired Pointing Griffon",
  "Wirehaired Vizsla",
  "Xiasi Dog",
  "Xoloitzcuintli",
  "Yakutian Laika",
  "Yorkshire Terrier",
];
